import React from 'react';

const MyHistory = () => {
    return (
        <div>
            <h1>My history</h1>
        </div>
    );
};

export default MyHistory;